export class ValidatorEvent
{
    public static SUCCESS: string = "form:validator.success";
    public static ERROR: string = "form:validator.error";
}
